import { BASE_API_DOMAIN, BASE_IMG_DOMAIN } from "./config.constant";
import ProductPlaceholerImg from "../assets/images/product/product-placeholder.png";
import BlogPlaceholerImg from "../assets/images/blog/blog-placeholder.png";
import CustomerPlaceholerImg from "../assets/images/customer/empty_avatar.png";

export const DEFAULT_FETCHING = {
  LIMIT: 12,
};

export const TEXT = { NOT_AVAILABLE: "N/A", EMPTY: "––/––" };

// Image
export const IMG_BASE_URL = {
  PRODUCT: `${BASE_IMG_DOMAIN}/uploads/products`,
  PRODUCT_CATEGORIES: `${BASE_IMG_DOMAIN}/uploads/categories`,
  PRODUCT_DESCRIPTION: `${BASE_IMG_DOMAIN}/uploads/descriptions`,
  TOPPING: `${BASE_IMG_DOMAIN}/uploads/products`,
  // TOPPING: `${BASE_IMG_DOMAIN}/uploads/toppings`,
  BLOG: `${BASE_IMG_DOMAIN}/uploads/blogs`,
  BLOG_CATEGORIES: `${BASE_IMG_DOMAIN}/uploads/blog-categories`,
  CUSTOMER: `${BASE_IMG_DOMAIN}/uploads/customers`,

  SOLUTION: `${BASE_IMG_DOMAIN}/uploads/solutions`,
  LANGUAGE: `${BASE_IMG_DOMAIN}/uploads/languages`,
  BANNER: `${BASE_IMG_DOMAIN}/uploads/banners`,
  FOCUSED_MARKET: `${BASE_IMG_DOMAIN}/uploads/focused-markets`,
  CAREER: `${BASE_IMG_DOMAIN}/uploads/career`,
  COUNTRY: `${BASE_IMG_DOMAIN}/uploads/countries`,
};

export const VIDEO_BASE_URL = {
  BASE: `${BASE_IMG_DOMAIN}/uploads/videos`,
}

// File
export const FILE_BASE_URL = {
  ORDER: `${BASE_API_DOMAIN}/uploads/orders`,
};

export const DEFAULT_IMG_ALT = "mi-dom-img";
export const DEFAULT_PRODUCT_IMG_PLACEHOLDER = ProductPlaceholerImg;
export const DEFAULT_BLOG_IMG_PLACEHOLDER = BlogPlaceholerImg;
export const DEFAULT_CUSTOMER_IMG_PLACEHOLDER = CustomerPlaceholerImg;
